<template>
    <v-container>
        <div class="mt-5" v-for="(skill, i) in skills" :key="i">
            <v-card class="d-flex justify-space-between">
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="title black--text pt-2 font-italic">{{skill.title}}</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="title black--text pt-2 font-italic">{{ skill.project }}+ projects</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="font-weight-bold">
                            <v-rating v-model="skill.rating">
                                <template v-slot:item="props">
                                    <v-icon
                                    :color="props.isFilled ? genColor(props.index) : 'grey lighten-1'"
                                    medium
                                    @click="props.click"
                                    >
                                    {{ props.isFilled ? 'mdi-star-circle' : 'mdi-circle-outline' }}
                                    </v-icon>
                                </template>
                            </v-rating>
                        </div>
                    </v-card-text>
                </v-card>
            </v-card>
            </div>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
      colors: ['black', 'black', 'black', 'black', 'black'],
      skills:[
          {title: 'LARAVEL, API', project: 65, rating: 4}, 
          {title: 'PHP', project: 65, rating: 4}, 
          {title: 'GIT', project: 105, rating: 4},
          {title: 'AWS', project: 5, rating: 4},
          {title: 'MYSQL', project: 65, rating: 4},
          {title: 'FIREBASE', project: 5, rating: 4},
          {title: 'JAVASCRIPT', project: 50, rating: 3}, 
          {title: 'VUE', project: 10, rating: 4}, 
          {title: 'HTML5', project: 65, rating: 4}, 
          {title: 'CSS3', project: 65, rating: 4}, 
          {title: 'BOOTSTRAP', project: 65, rating: 4}, 
          {title: 'VUETIFYJS', project: 11, rating: 4},
      ]
    }),
    methods: {
      genColor (i) {
        return this.colors[i]
      },
    },
  }
</script>